/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { SharedMaterialModule } from './shared-material.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { HeaderComponent } from '../layout/common/components/header/header.component';
import { AlertsComponent } from './alerts/alerts.component';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';



@NgModule({
  declarations: [PasswordChangeComponent, TimeoutComponent,  PrivacyPolicyComponent, GlobalLoaderComponent, HeaderComponent, AlertsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedMaterialModule,
    RouterModule,
    MatExpansionModule
  ],
  exports: [
    PasswordChangeComponent,
    TimeoutComponent,
    GlobalLoaderComponent,
    AlertsComponent,
    ReactiveFormsModule,
    FormsModule,
    HeaderComponent,
    CommonModule,
    MatExpansionModule
  ]
})
export class SharedModule { }
